import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const proteinTranslationTool: Tool = {
  id: "protein-translation",
  name: () => m.translate_tool_name(),
  description: () => m.translate_tool_description(),
  icon: "🧬",
  basePath: "/protein-translation",
  status: "stable",
  tags: ["bioinformatics", "dna", "rna", "protein", "science", "translation"],
};
